import {useState, useCallback} from 'react'
import {useSnackbar} from 'notistack'
import {getGeneric} from '../../common/constants'

/**
 * Every merchant allowed the PACE entry in its allocation rules, with its PACE live + shadow-compare
 * state (dynamiccourier/pace/admin/brands; omitting the ?version filter returns all of them). PACE
 * only ranks rules that carry the PACE entry, so this set is every merchant PACE can be turned on for.
 */
export function usePaceV2MerchantList() {
  const [isLoading, setIsLoading] = useState(false)
  const [brands, setBrands] = useState([])
  const [totalBrands, setTotalBrands] = useState(0)
  const {enqueueSnackbar} = useSnackbar()

  const loadBrands = useCallback(async () => {
    setIsLoading(true)
    setBrands([])
    setTotalBrands(0)
    try {
      // no version filter ⇒ every PACE merchant, live or not
      const res = await getGeneric('dynamiccourier/pace/admin/brands', {})
      const data = res.data?.result || res.data?.data || res.data
      setBrands(data?.brands || [])
      setTotalBrands(data?.totalBrands || 0)
    } catch (err) {
      enqueueSnackbar('Failed to load PACE merchant list', {variant: 'error'})
    } finally {
      setIsLoading(false)
    }
  }, [enqueueSnackbar])

  // Optimistically patch one merchant's row after an engine/shadow write, so the toggle reflects
  // immediately without a full reload (and the row doesn't drop out of an active version filter).
  const patchBrand = useCallback((merchantOid, patch) => {
    setBrands((prev) => prev.map((b) => (b.merchantOid === merchantOid ? {...b, ...patch} : b)))
  }, [])

  return {isLoading, brands, totalBrands, loadBrands, patchBrand}
}
